export var RADIO_BUTTON_SHAPES = Object.freeze({
  squared: 'squared',
  pill: 'pill'
});